/**
 * @memberOf loavies.models.chat
 * @constructor
 */
export class TalkJsChatModel {
  /**
   * @param {string} id
   * @param {string} [subject]
   * @param {string} [topicId]
   * @param {string} [photoUrl]
   * @param {string[]} [welcomeMessages]
   * @param {Object} [custom]
   * @param {loavies.models.chat.ChatMessageModel} [lastMessage]
   * @param {string[]} participants
   * @param {number} createdAt UnixMilliseconds
   */
  constructor({
    id,
    subject,
    topicId,
    photoUrl,
    welcomeMessages,
    custom,
    lastMessage,
    participants,
    createdAt,
  }) {

    /** @type {string} */
    this.id = id

    /** @type {string} */
    this.subject = subject

    /** @type {string} */
    this.topicId = topicId

    /** @type {string} */
    this.photoUrl = photoUrl

    /** @type {string[]} */
    this.welcomeMessages = welcomeMessages

    /** @type {Object} */
    this.custom = custom

    /** @type {loavies.models.chat.ChatMessageModel} */
    this.lastMessage = lastMessage

    /** @type {string[]} */
    this.participants = participants

    /** @type {number} */
    this.createdAt = createdAt
  }
}
